window.BrazeService = (function () {
  const MAX_RETRIES = 10;
  const RETRY_DELAY = 1000;

  const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

  // Execute function when Braze SDK is ready, with retry mechanism
  const executeWhenSDKReady = async (fn, retries = 1) => {
    const isBrazeSDKReady =
      typeof window.braze !== "undefined" && window.braze.initialize;

    if (isBrazeSDKReady) {
      return await fn();
    }

    if (retries <= MAX_RETRIES) {
      console.log("[Braze] SDK not ready, retrying ...");
      await sleep(RETRY_DELAY);
      return await executeWhenSDKReady(fn, retries + 1);
    }

    const errorMessage = "[Braze] SDK not found";
    console.error(errorMessage);
    throw new Error(errorMessage);
  };

  return {
    // Wait for SDK to be ready
    waitForBrazeSDK: async function () {
      try {
        await executeWhenSDKReady(() => Promise.resolve());
        console.log("[Braze] SDK is ready");
        return true;
      } catch (error) {
        console.error(`[Braze] ${error.message}`);
        return false;
      }
    },

    // Enable in-app messages
    enableInAppMessages: async function () {
      try {
        await executeWhenSDKReady(() => {
          // Subscribe to debug
          window.braze.subscribeToInAppMessage(function (inAppMessage) {
            // Show message
            window.braze.showInAppMessage(inAppMessage);
          });

          // Enable auto display
          window.braze.automaticallyShowInAppMessages();
          console.log("[Braze] In-app messages enabled and subscribed");
        });
        return true;
      } catch (error) {
        console.error(`[Braze] Enable in-app messages failed: ${error}`);
        return false;
      }
    },

    // Log custom event
    logCustomEvent: async function (eventName, properties = {}) {
      try {
        await executeWhenSDKReady(() => {
          window.braze.logCustomEvent(eventName, properties);
        });
      } catch (error) {
        console.error(`[Braze] Log event failed: ${error}`);
      }
    },

    // Request immediate data flush
    requestImmediateDataFlush: async function () {
      try {
        await executeWhenSDKReady(() => {
          window.braze.requestImmediateDataFlush();
          console.log("[Braze] Data flushed");
        });
      } catch (error) {
        console.error(`[Braze] Flush failed: ${error}`);
      }
    },
  };
})();
